import { render, staticRenderFns } from "./TaskDialogComponent.vue?vue&type=template&id=78bf8664&scoped=true"
import script from "./TaskDialogComponent.vue?vue&type=script&lang=js"
export * from "./TaskDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf8664",
  null
  
)

export default component.exports